import { Outlet } from "react-router";

const ClinicToClinicTranfer = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default ClinicToClinicTranfer;
